import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { checkDarkMode } from "../utils/helpers";

const InfoCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  background-color: ${({ $backgroundColor, theme }) =>
    checkDarkMode($backgroundColor, theme) || theme.colors.secondary};
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  padding: ${({ $variant }) =>
    $variant === "column" ? "2rem 1rem" : "0 10px"};
  margin: 1rem 2px;
  align-items: ${({ $alignContent }) => $alignContent};
  justify-content: ${({ $alignContent, $variant }) =>
    $variant === "column" ? "flex-start" : $alignContent};
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: 100%;
    padding: 1.5rem 0.5rem;
    margin: 0;
  }
`;
const InnerWrapper = styled.div`
  display: flex;
  flex-flow: ${({ $variant }) =>
    $variant === "column" ? "column wrap" : "row nowrap"};
`;
const Heading = styled.p`
  font-size: ${({ $variant }) => ($variant === "column" ? "1rem" : "1.3rem")};
  font-weight: 600;
  padding: ${({ $variant }) =>
    $variant === "column" ? "0 1.5rem" : "0 1.5rem 0 0"};
  margin: auto 0;
  width: auto;
  text-align: start;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-flow: ${({ $variant }) =>
    $variant === "column" ? "column wrap" : "row nowrap"};
  color: ${({ $textColorHex, theme }) => $textColorHex || theme.colors.black};
  align-items: ${({ $alignContent, $variant }) =>
    $variant === "column" ? $alignContent : "center"};
  justify-content: ${({ $alignContent }) => $alignContent};
`;
const InfoText = styled.p`
  font-size: 0.9rem;
  padding: ${({ $variant }) =>
    $variant === "column" ? "0 1.5rem" : "0 1.5rem 0 0"};
  margin: 0;
  text-align: ${({ $alignContent }) =>
    $alignContent === "flex-end"
      ? "end"
      : $alignContent === "flex-start"
        ? "start"
        : $alignContent === "center"
          ? "center"
          : "start"};
`;
const IconWrapper = styled.div`
  display: flex;
  justify-content: ${({ $alignContent }) => $alignContent};
  padding: ${({ $variant }) =>
    $variant === "column" ? "0 2rem 1.5rem 2rem" : "0 10px 0 0"};
  align-items: center;
`;
const Icon = styled(FontAwesomeIcon)`
  font-size: ${({ $variant }) =>
    $variant === "column" ? "3rem!important" : "1.5rem!important"};
  color: ${({ $iconcolor, theme }) =>
    checkDarkMode($iconcolor, theme) || theme.colors.primary};
`;

export default function InfoCard({
  title,
  text,
  icon,
  variant,
  alignContent,
  backgroundColorHex,
  textColorHex,
  iconColorHex,
  className,
}) {
  return (
    <InfoCardWrapper
      $variant={variant}
      $backgroundColor={backgroundColorHex}
      $alignContent={alignContent}
      $textColor={textColorHex}
      className={className}
    >
      <InnerWrapper $variant={variant}>
        {icon && (
          <IconWrapper $alignContent={alignContent} $variant={variant}>
            <Icon $variant={variant} icon={icon} $iconcolor={iconColorHex} />{" "}
          </IconWrapper>
        )}

        <TextWrapper
          $variant={variant}
          $textColorHex={textColorHex}
          $alignContent={alignContent}
        >
          {title && <Heading $variant={variant}>{title}</Heading>}
          {text && (
            <InfoText $alignContent={alignContent} $variant={variant}>
              {text}
            </InfoText>
          )}
        </TextWrapper>
      </InnerWrapper>
    </InfoCardWrapper>
  );
}

InfoCard.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.object,
  variant: PropTypes.string,
  alignContent: PropTypes.string,
  backgroundColorHex: PropTypes.string,
  textColorHex: PropTypes.string,
  iconColorHex: PropTypes.string,
  className: PropTypes.string,
};
InfoCard.defaultProps = {
  title: "",
  text: "",
};
